import React from "react";
import ArrowRight from "../../assets/svg/ArrowRight";
import ProfileIcon from "../../assets/svg/ProfileIcon";

const UserProfile = ({ onClick }) => {
  return (
    <div
      className="order-summary-inner bg-white cursor-pointer rounded-lg"
      onClick={onClick}
    >
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-2">
          <div className="border border-1 p-[6px]  border-gray-400 rounded-[4px]">
            <ProfileIcon width={12} height={12} />
          </div>
          <div>
            <p className="text-[18px] supreme-medium">Account</p>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <ArrowRight width={14} height={14} className="fill-gray-500" />
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
